import React from 'react';
import classNames from 'classnames';

import { ProgressLineProps } from './progress-line.type';

export const ProgressLine = ({
  percentageProgress,
  borderRadiusClassName = 'rounded-xl',
  backgroundColorClassName = 'fill-primary',
  progressLineColorClassName = 'fill-dark',
  heightClassName = 'h-3 ',
}: ProgressLineProps) => {
  return (
    <div className={classNames('w-full', borderRadiusClassName, backgroundColorClassName, heightClassName)}>
      <div
        className={classNames(borderRadiusClassName, progressLineColorClassName, heightClassName)}
        style={{ width: `${percentageProgress}%` }}></div>
    </div>
  );
};
